import { SpecialtyPage } from '@/features/specialty-page';

export default function filterMainComponent<
  T extends SpecialtyPage['components'][0],
>(specialtyPage: SpecialtyPage, component: T['__typename']): T[] {
  return specialtyPage.components?.filter(
    (c) => c.__typename === component
  ) as T[];
}
